import { ScaffolderInputHeader } from '@internal/plugin-scaffolder-common-field-react';
import React from 'react';

import { Box } from '@material-ui/core';

import { KaapTenantPicker, KaapTenant } from '../../KaapTenantPicker';
import { KAAP_CLUSTER_INFO } from '../infoDoc';
import { KaapCluster } from '../types';
import { NamespaceInput } from './NamespaceInput';

interface KaapClusterPickerProps {
  formData: KaapCluster;
  onChange: (data: KaapCluster) => void;
  rawErrors: string[];
}

export const KaapClusterPicker = (props: KaapClusterPickerProps) => {
  const { formData, onChange, rawErrors } = props;

  const handleClusterChange = (tenant: KaapTenant | string = '') => {
    if (!tenant) {
      onChange({ tenant: null, namespaces: [] });
    } else {
      const tenantName = typeof tenant === 'string' ? tenant : tenant.name;
      onChange({
        tenant:
          typeof tenant === 'string'
            ? { name: tenant, clusterId: null }
            : tenant,
        namespaces: [`kaap-${tenantName}-*`],
      });
    }
  };

  const handleNamespacesChanged = (namespaces: string[]) => {
    onChange({
      ...(formData || {
        tenant: null,
        namespaces: [],
      }),
      namespaces: namespaces,
    });
  };

  return (
    <Box>
      <ScaffolderInputHeader
        title="Tenant"
        description="Select the tenant for this cluster."
        infoDoc={KAAP_CLUSTER_INFO}
      />
      <KaapTenantPicker
        onChange={e => handleClusterChange(e)}
        schema={{
          title: 'Tenant Name',
          type: 'object',
        }}
        formData={formData?.tenant || ''}
        uiSchema={{}}
        idSchema={[] as any}
        onBlur={() => {}}
        onFocus={() => {}}
        registry={{} as any}
        disabled={false}
        readonly={false}
        required
        name="Tenants"
        rawErrors={rawErrors}
      />
      <NamespaceInput
        formData={formData?.namespaces || []}
        onChange={handleNamespacesChanged}
        rawErrors={rawErrors}
        disabled
      />
    </Box>
  );
};
